/* eslint-disable no-useless-catch */
/* eslint-disable unused-imports/no-unused-vars */
import { API } from "../api";
import { COUNTRIES_URL } from "../constants/url.constant";

export const ADD_HUB = "ADD_HUB";
export const GET_COUNTRIES = "GET_COUNTRIES";
export const DELETE_HUB = "DELETE_HUB";
export const UPDATE_HUB = "UPDATE_HUB";

export const getCountryList = (data) => ({
  type: GET_COUNTRIES,
  payload: data
});

export const addHub = (data) => ({
  type: ADD_HUB,
  payload: data
});

export const updateHub = (data) => ({
  type: UPDATE_HUB,
  payload: data
});

export const deleteHub = (id) => ({
  type: DELETE_HUB,
  payload: id
});

export const getCountries = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(COUNTRIES_URL, {
        params
      });
      if (Object.keys(params).length) {
        dispatch(getCountryList(res));
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const createHub = (data) => async (dispatch) => { };

export const editHub = (data) => async (dispatch) => { };

export const removeHub = (data) => async (dispatch) => { };

export default function reducer(state = [], { type, payload }) {
  switch (type) {
    case GET_COUNTRIES:
      return {
        ...state,
        countryList: payload
      };
    case ADD_HUB:
      return {
        ...state
        // .concat([action.data])
      };
    case DELETE_HUB:
      return {
        ...state
      };
    //   state.filter((post) => post.id !== action.id);
    case UPDATE_HUB:
      return {
        ...state
      };
    //   return state.map((post) =>
    //     post.id === action.id ? { ...post, editing: !post.editing } : post
    //   );
    default:
      return state;
  }
}
